import { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  it: {
    valliRider: "ValliRider",
    est: "",
    configure: "Configura",
    rides: "Percorsi",
    logout: "Esci",
    designYourRoute: "Progetta il tuo percorso",
    configurator: "// Configuratore",
    vehicle: "Mezzo",
    moto: "Moto",
    ebike: "Bike / E-Bike",
    walk: "A Piedi",
    routeType: "Tipo percorso",
    mode: "Modalità",
    loop: "Circuito ad Anello",
    andataRitorno: "Andata e Ritorno",
    destination: "Destinazione",
    community: "Giri Pronti",
    andataRitornoDesc: "Tracciato lineare con rientro sullo stesso percorso (o varianti).",
    turnLocation: "Direzione / Località di svolta",
    optional: "opzionale",
    turnPlaceholder: "Es. Gubbio, Monte Cucco, Mare…",
    remove: "Rimuovi",
    activateGps: "ATTIVA GPS",
    gpsActive: "GPS ATTIVO",
    gpsTitle: "Usa la tua posizione GPS come partenza",
    direction: "Direzione",
    parameter: "Parametro",
    kilometers: "Chilometri",
    time: "Tempo",
    distance: "Distanza",
    offroad: "Off-Road",
    terrain: "Terreno",
    terrainPrefNote: "(preferenza, non vincolo)",
    terrainTurismo: "Turismo",
    terrainTurismoDesc: "Asfalto e viabilità scorrevole",
    terrainSterrato: "Sterrato Facile",
    terrainSterratoDesc: "Strade bianche, rurali e forestali battute",
    terrainAdventure: "Misto / Adventure",
    terrainAdventureDesc: "Bilanciamento tra asfalto e fuoristrada medio",
    terrainEnduro: "Enduro / Hard",
    terrainEnduroDesc: "Fuoristrada tecnico, trail e percorsi impegnativi",
    terrainInfo: "Il terreno indica la tua preferenza. ValliRider cercherà il percorso migliore entro distanza e durata impostate.",
    difficulty: "Difficoltà",
    easy: "Facile",
    medium: "Medio",
    hard: "Difficile",
    startPoint: "Punto di partenza",
    manual: "Manuale",
    gpsNow: "GPS attuale",
    change: "Cambia",
    suggestions: "Suggerimenti",
    searchPlaceholder: "Scrivi una città, valle, passo… (Invio per cercare)",
    searching: "Ricerca…",
    noResults: "Nessun risultato — prova con un nome diverso",
    searchUnavailable: "Ricerca non disponibile, riprova",
    generate: "Genera",
    generatePercorso: "Genera percorso",
    generateAR: "Genera A/R",
    computePath: "Calcola percorso",
    generating: "Sto generando…",
    calculating: "Calcolo in corso…",
    save: "Salva",
    saving: "Salvo…",
    duration: "Durata",
    elevation: "Dislivello",
    offRoadKm: "Off-Road",
    previewStale: "⚠ Anteprima aggiornata — premi Genera per rigenerare",
    yourRides: "I tuoi percorsi",
    logbook: "// Diario",
    noSaved: "Nessun percorso salvato",
    noSavedDesc: "Torna al configuratore per generare e salvare il tuo primo percorso.",
    kilometersUnit: "KILOMETRI",
    metersUnit: "METRI",
    loading: "Caricamento roadbook…",
    authenticating: "Autenticazione rider…",
    tagline: "ValliRider • Off-Road Navigation",
    heading1a: "Vivi le",
    heading1b: "valli",
    heading2a: "Progetta il tuo",
    heading2b: "percorso",
    landingDesc: "Configuratore di percorsi per i riders: scegli il mezzo, i chilometri, la dose di off-road. ValliRider costruisce l'itinerario perfetto sulle strade delle valli italiane.",
    enterRoadbook: "Disegna il tuo percorso",
    redirecting: "Reindirizzo…",
    signInWith: "Accedi con Google via Emergent Auth",
    featLoopTitle: "Genera Percorsi",
    featLoopDesc: "Percorsi generati sulla mappa reale con OpenStreetMap.",
    featBikeTitle: "Moto & E-Bike",
    featBikeDesc: "Due profili di guida — dalle moto alle bike/e-bike.",
    featOffroadTitle: "Selettore Off-Road",
    featOffroadDesc: "Slider dedicato: sterrato, ghiaia, valichi militari.",
    featDataTitle: "Roadbook Data",
    featDataDesc: "Distanza, dislivello, difficoltà: tutto in stile roadbook.",
    // Toasts
    geoUnavailable: "Geolocalizzazione non disponibile",
    geoAcquired: "Posizione GPS acquisita",
    geoDenied: "Geolocalizzazione negata",
    gpsDeactivated: "GPS disattivato",
    routeGenerated: "Percorso generato",
    selectDestFirst: "Seleziona prima una destinazione",
    generateFirst: "Genera prima un percorso",
    // Voice
    voiceListening: "Ascolto…",
    voiceConfirmed: "Confermato — genero il percorso.",
    voiceCancelled: "Annullato. Premi di nuovo il microfono per ricominciare.",
    voiceNotUnderstood: "Non ho capito. Riprova.",
    voiceLocaleTag: "it-IT",
    voiceCmd: "Comando vocale",
    // Map / turn marker
    turnLabel: "Svolta",
    kmShort: "km",
    // Rides page
    ridesTitle: "Le tue rides",
    ridesLoadError: "Impossibile caricare i percorsi",
    ridesDeleted: "Percorso eliminato",
    ridesDeleteError: "Errore eliminazione",
    noSavedLoop: "Nessun loop salvato",
    ridesEmptyDesc: "Torna al configuratore per generare e salvare il tuo primo percorso ad anello.",
    startShort: "Start",
    difficultyShort: "Difficoltà",
    // PublicRoute page
    publicNotFound: "Percorso non trovato o link scaduto.",
    publicLoadError: "Errore nel caricamento del percorso.",
    publicBackHome: "Torna alla home",
    publicLoading: "Caricamento percorso…",
    publicSharedRoute: "Percorso condiviso",
    publicCreateYours: "Crea il tuo",
    publicLoopType: "Anello",
    publicDestType: "Destinazione",
    publicARType: "Andata e Ritorno",
    publicGpxCta: "Scarica GPX Gratis",
    publicGpxLoading: "Preparo il file…",
    publicGpxHint: "Nessun account richiesto · Compatibile con Garmin · Wahoo · Komoot",
    publicLikeQ: "Ti è piaciuto questo giro?",
    publicConvertDesc: "Scarica l'app ValliRider per generare infiniti percorsi fuoristrada con un click.",
    publicOpenApp: "Apri ValliRider",
    // Tracking voice commands
    trackVoiceHelp: "Comandi vocali: \"stop\", \"pausa\", \"spegni voce\", \"accendi voce\"",
    trackVoiceListening: "Ascolto comandi…",
    trackVoiceOff: "Comandi vocali disattivati",
  },
  en: {
    valliRider: "ValliRider",
    est: "",
    configure: "Configure",
    rides: "Rides",
    logout: "Log out",
    designYourRoute: "Design your route",
    configurator: "// Configurator",
    vehicle: "Vehicle",
    moto: "Moto",
    ebike: "Bike / E-Bike",
    walk: "On Foot",
    routeType: "Route type",
    mode: "Mode",
    loop: "Loop Circuit",
    andataRitorno: "Out & Back",
    destination: "Destination",
    community: "Ready Rides",
    andataRitornoDesc: "Linear track with return on the same route (or variants).",
    turnLocation: "Direction / Turn Location",
    optional: "optional",
    turnPlaceholder: "E.g. Gubbio, Monte Cucco, Sea…",
    remove: "Remove",
    activateGps: "ENABLE GPS",
    gpsActive: "GPS ACTIVE",
    gpsTitle: "Use your GPS position as start",
    direction: "Direction",
    parameter: "Parameter",
    kilometers: "Kilometers",
    time: "Time",
    distance: "Distance",
    offroad: "Off-Road",
    terrain: "Terrain",
    terrainPrefNote: "(preference, not a constraint)",
    terrainTurismo: "Touring",
    terrainTurismoDesc: "Asphalt & flowing roads",
    terrainSterrato: "Easy Gravel",
    terrainSterratoDesc: "Gravel, rural & forest roads",
    terrainAdventure: "Mixed / Adventure",
    terrainAdventureDesc: "Balanced asphalt + mid off-road",
    terrainEnduro: "Enduro / Hard",
    terrainEnduroDesc: "Technical off-road, trails & demanding routes",
    terrainInfo: "Terrain is a preference. ValliRider will find the best route within your set distance and duration.",
    difficulty: "Difficulty",
    easy: "Easy",
    medium: "Medium",
    hard: "Hard",
    startPoint: "Start point",
    manual: "Manual",
    gpsNow: "Current GPS",
    change: "Change",
    suggestions: "Suggestions",
    searchPlaceholder: "Type a city, valley, pass… (Enter to search)",
    searching: "Searching…",
    noResults: "No results — try a different name",
    searchUnavailable: "Search unavailable, please retry",
    generate: "Generate",
    generatePercorso: "Generate route",
    generateAR: "Generate O&B",
    computePath: "Compute route",
    generating: "Generating…",
    calculating: "Computing…",
    save: "Save",
    saving: "Saving…",
    duration: "Duration",
    elevation: "Elevation",
    offRoadKm: "Off-Road",
    previewStale: "⚠ Preview updated — hit Generate to regenerate",
    yourRides: "Your rides",
    logbook: "// Logbook",
    noSaved: "No saved routes",
    noSavedDesc: "Head back to the configurator to build and save your first route.",
    kilometersUnit: "KILOMETERS",
    metersUnit: "METERS",
    loading: "Loading roadbook…",
    authenticating: "Authenticating rider…",
    tagline: "ValliRider • Off-Road Navigation",
    heading1a: "Ride the",
    heading1b: "valleys",
    heading2a: "Design your",
    heading2b: "route",
    landingDesc: "Route configurator for riders: pick your vehicle, kilometers, and off-road dose. ValliRider builds the perfect route across Italy's iconic valley roads.",
    enterRoadbook: "Design your route",
    redirecting: "Redirecting…",
    signInWith: "Sign in with Google via Emergent Auth",
    featLoopTitle: "Generate Routes",
    featLoopDesc: "Routes built on live OpenStreetMap data.",
    featBikeTitle: "Moto & E-Bike",
    featBikeDesc: "Two ride profiles — from motorcycles to bikes/e-bikes.",
    featOffroadTitle: "Off-Road Selector",
    featOffroadDesc: "Dedicated slider: dirt, gravel, alpine passes.",
    featDataTitle: "Roadbook Data",
    featDataDesc: "Distance, elevation, difficulty — roadbook style.",
    // Toasts
    geoUnavailable: "Geolocation unavailable",
    geoAcquired: "GPS position acquired",
    geoDenied: "Geolocation denied",
    gpsDeactivated: "GPS disabled",
    routeGenerated: "Route generated",
    selectDestFirst: "Pick a destination first",
    generateFirst: "Generate a route first",
    // Voice
    voiceListening: "Listening…",
    voiceConfirmed: "Confirmed — generating route.",
    voiceCancelled: "Cancelled. Tap the mic again to restart.",
    voiceNotUnderstood: "Didn't catch that. Try again.",
    voiceLocaleTag: "en-US",
    voiceCmd: "Voice command",
    // Map / turn marker
    turnLabel: "Turn",
    kmShort: "km",
    // Rides page
    ridesTitle: "Your rides",
    ridesLoadError: "Couldn't load your rides",
    ridesDeleted: "Ride deleted",
    ridesDeleteError: "Delete failed",
    noSavedLoop: "No saved loops",
    ridesEmptyDesc: "Head back to the configurator to build and save your first loop.",
    startShort: "Start",
    difficultyShort: "Difficulty",
    // PublicRoute page
    publicNotFound: "Route not found or link expired.",
    publicLoadError: "Error loading route.",
    publicBackHome: "Back to home",
    publicLoading: "Loading route…",
    publicSharedRoute: "Shared route",
    publicCreateYours: "Create yours",
    publicLoopType: "Loop",
    publicDestType: "Destination",
    publicARType: "Out & Back",
    publicGpxCta: "Free GPX Download",
    publicGpxLoading: "Preparing file…",
    publicGpxHint: "No account required · Works with Garmin · Wahoo · Komoot",
    publicLikeQ: "Enjoyed this ride?",
    publicConvertDesc: "Download the ValliRider app to generate endless off-road routes with one tap.",
    publicOpenApp: "Open ValliRider",
    // Tracking voice commands
    trackVoiceHelp: "Voice commands: \"stop\", \"pause\", \"voice off\", \"voice on\"",
    trackVoiceListening: "Listening for commands…",
    trackVoiceOff: "Voice commands off",
  },
};

const I18nCtx = createContext(null);

function detectLang() {
  const stored = localStorage.getItem("brema-lang");
  if (stored === "it" || stored === "en") return stored;
  const nav = (navigator.language || navigator.userLanguage || "en").toLowerCase();
  return nav.startsWith("it") ? "it" : "en";
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectLang);
  useEffect(() => {
    localStorage.setItem("brema-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const setLang = (l) => setLangState(l);
  const t = (key) => DICT[lang][key] ?? DICT.en[key] ?? key;
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
